import apiClient from '@/services/axios'

const getAll = async (params) => {
  const res = await apiClient.get('/pharmacy-assessments', { params })
  if (res) {
    return res.data
  } else {
    return []
  }
}

const getById = async (id) => {
  const res = await apiClient.get(`/pharmacy-assessments/${id}`)
  if (res) {
    return res.data
  } else {
    return null
  }
}

export {
  getAll,
  getById,
}
